import { state } from "../../state/workspaceStore.js";
export function searchbar(placeholder, options = []) {
  return (
    <div className="toolbar">
      <input
        key={state.query}
        id="search"
        aria-label="Search"
        placeholder={placeholder}
        defaultValue={state.query}
      />
      {options.length > 0 && (
        <select
          key={state.filter}
          id="filter"
          aria-label="Filter"
          defaultValue={state.filter}
        >
          {options.map((x) => (
            <option key={x} value={x}>
              {x}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}
